import React from 'react'
import ModalV4 from "../../../../app/ui/modal/v4/v4"

import ItemViewTop from "../../../../layout/top/item-view-top/item-view-top"
import UI5MenuItem from "../../../gd-components/menu/ui5-menu/ui5-menu-item"
import ProjectTeamIcon from "./components/project-team-icon/project-team-icon"
import ModalProjectTeamActions from "./actions/team-actions"
import ProjectUserFull from "../../../model2/project-user/project-user-full"
import ModalTeamDefault from "./components/views/default-view"
import ModalTeamConfirm from "./components/views/confirm-view"
import {USER_VIEW_TYPE} from "../@type";
import ReassignUsersView from "./components/views/reassign-users-view";
import ProjectUsersFullCollection from "../../../model2/project-user/collection-full";
import UserAssignment_Collection from "../model/collection";

type Props = {
    params: {
        ownerUserId     : ID
        projectUser     : ProjectUserFull
        projectUsers    : ProjectUsersFullCollection
        userAssignments : UserAssignment_Collection
        onReassignDone  : callback
        onChange        : callback
    }
}

export default class ModalTeamView extends ModalV4 {

    private actions     : ModalProjectTeamActions

    constructor(props: Props) {
        super(props);

        this.state = {
            view            : this.props.params.userAssignments?.isEmpty ? USER_VIEW_TYPE.DEFAULT : USER_VIEW_TYPE.REASSIGN_DELETE,
            userAssignments : this.props.params.userAssignments
        }

        this.actions = new ModalProjectTeamActions(this.props.params, this.update, this.reassignItems, this.closeModal)

    }

    update = (callback: callback) => {
        this.forceUpdate(callback)
    }

    onCancel = () => {
        this.setState({
            view: USER_VIEW_TYPE.DEFAULT
        });
    }

    reassignItems = (view: USER_VIEW_TYPE, userAssignments: UserAssignment_Collection) => {
        this.setState({
            view            : view,
            userAssignments : userAssignments
        })
    }

    renderViewContent() {

        const menuItemAccess = {
            id: 'default',
            icon: 'ii5-information',
            label: 'Project access',
            onClick: this.onCancel
        }

        const  menuItemDelete = {
            id          : 'delete',
            icon        : 'i5-trash-alt',
            label       : 'Delete team',
            className   : "red",
            onClick     : this.actions.onDeleteConfirmed
        }

        const title = gd.spaces.workspaces.getByProjectId(this.props.params.projectUser.projectId) ? 'Workspace team' : 'Project team'

        switch (this.state.view) {
            // case USER_VIEW_TYPE.CONFIRM:
            //     return (
            //         <ModalTeamConfirm projectUser       = {this.props.params.projectUser}
            //                           reasonCantDelete  = {this.state.reasonCantDelete}
            //                           onCancel          = {this.onCancel}/>
            //     )

            case USER_VIEW_TYPE.REASSIGN_ACCESS:
            case USER_VIEW_TYPE.REASSIGN_DELETE:
                return (
                    <div className="v4-container placement-middle ui5-iv w-650"
                         style={{height: 785}}
                         onClick={this.stopPropagation}>
                        <ReassignUsersView reassignType         = {this.state.view}
                                           projectUser          = {this.props.params.projectUser}
                                           projectUsers         = {this.props.params.projectUsers}
                                           userAssignments      = {this.state.userAssignments}
                                           actions              = {this.actions}
                                           onCloseModal         = {this.closeModal}/>
                    </div>
                )

            default:
                return (
                    <div className="v4-container placement-middle ui5-iv view-project-user" onClick={this.stopPropagation}>
                        <ItemViewTop title={title} onCloseClick={this.closeModal}/>

                        <div className="iv-left-column">
                            <ProjectTeamIcon projectId={this.props.params.projectUser.projectId} teamId={this.props.params.projectUser.teamId}/>

                            <div className="ui5-menu p-t-0">
                                <UI5MenuItem item={menuItemAccess} selectedId={this.state.view}/>
                                {this.props.params.projectUser.acl.canDelete &&
                                    <UI5MenuItem item={menuItemDelete} selectedId={this.state.view}/>
                                }

                            </div>
                        </div>
                        <ModalTeamDefault projectUser={this.props.params.projectUser}
                                          projectUsers={this.props.params.projectUsers}
                                          actions={this.actions}/>
                    </div>
                )
        }
    }

    render() {
        return this.renderViewContent()
    }
}
